import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReadinessPerson } from '../../../../services/suburb-readiness.service';
import { ReadinessFilters } from '../workspace/readiness-view.service';
import { MISSING_OPTIONS, STATUS_OPTIONS } from './readiness-rules';

type Groups = Array<{ label: string; items: Array<{ label: string; value: string }> }>;

/** The Readiness view's filters (#262). Presentational: each change is a new filters object for the host. */
@Component({
  selector: 'app-readiness-filters',
  templateUrl: './readiness-filters.component.html',
  styleUrls: ['./readiness-filters.component.scss'],
})
export class ReadinessFiltersComponent {
  @Input() filters!: ReadinessFilters;
  @Input() regionOptions: Array<{ label: string; value: string }> = [];
  @Input() set subRegionGroups(groups: Groups) {
    this.subRegionOptions = [
      { label: 'Any', items: [{ label: 'In no sub-region', value: 'none' }] },
      ...(groups ?? []),
    ];
  }
  @Input() set owners(people: ReadinessPerson[]) {
    this.ownerOptions = [
      { label: 'Nobody', value: 'none' },
      ...people.map((p) => ({ label: p.name, value: String(p.userId) })),
    ];
  }
  @Output() changed = new EventEmitter<ReadinessFilters>();
  @Output() reset = new EventEmitter<void>();

  subRegionOptions: Groups = [];
  ownerOptions: Array<{ label: string; value: string }> = [];
  readonly missingOptions = MISSING_OPTIONS;
  readonly statusOptions = STATUS_OPTIONS;
  readonly publishedOptions = [
    { label: 'Published', value: 'yes' },
    { label: 'Not published', value: 'no' },
  ];
  readonly kindOptions = [
    { label: 'Suburb pages', value: 'suburb' },
    { label: 'Sub-region pages', value: 'subregion' },
  ];

  set<K extends keyof ReadinessFilters>(key: K, value: ReadinessFilters[K]): void {
    this.changed.emit({
      ...this.filters,
      [key]: value ?? (key === 'missing' ? [] : key === 'q' ? '' : null),
    });
  }

  get anyFilter(): boolean {
    return Object.values(this.filters).some((v) => (Array.isArray(v) ? v.length > 0 : !!v));
  }
}
